import { makeStyles } from "@material-ui/core/styles";

export const tabStyle = makeStyles(() => ({
  tabs: {
    "& .MuiTab-root": {
      fontFamily: "var(--font-family-diodrum)",
      color: "var(--color-primary-black)",
      fontSize: "var(--size-16px)",
      padding: "0px 30px 0px 0px",
      minWidth: "fit-content",
      marginRight: 15,
      lineHeight: 1,
      opacity: 1,
      cursor: "pointer",
      textTransform:'none'
    },
    "& .MuiTab-wrapper": {
      textTransform: "none",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
    "& .Mui-selected": {
      color: "var(--color-primary) !important",
      fontFamily: "var(--font-family-diodrum_semi-bold)",
      fontSize: "var(--size-16px)",
      textTransform:'none',
   
    },
    "& .Mui-selected .tab__title": {
      borderBottom: "4px solid var(--color-primary)",
    },
  },
  badgeContainer: {
    display: "flex",
    alignItems: "center",
    "& label": {
      cursor: "pointer",
    },
  },
  badge: {
    fontSize: "var(--size-16px)",
    fontFamily: "var(--font-family-diodrum_semi-bold)",
    backgroundColor: "var(--color-pale-teal)",
    color: "var(--color-primary)",
    padding: "4px 10px 2px 10px",
    marginLeft: 5,
    borderRadius: 2,
    marginBottom: 15,
  },
}));
